import script from "./UserPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPanel.vue?vue&type=script&setup=true&lang=ts"

import "./UserPanel.vue?vue&type=style&index=0&id=3e656cd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e656cd4"]])

export default __exports__